import type Variant from '@modules/product/type/variant';
import PriceUnitEnum from '@modules/product/type/price-unit-enum';
import { pxToRem, useAppDisplayModeContext } from '@archipro-design/aria';

const PRICE_UNIT_LABELS = {
    CubicMetre: 'cubic metre',
    LinearMetre: 'metre',
    SquareMetre: 'square metre',
    Box: 'box',
};

interface Props {
    variant: Pick<Variant, 'PriceUnit' | 'QuantityPerUnit' | 'CoverageArea'>;
    isPriceRange?: boolean;
}

export const PriceUnit = ({ variant, isPriceRange }: Props) => {
    const { mobile } = useAppDisplayModeContext();

    if (!variant.PriceUnit || variant.PriceUnit === PriceUnitEnum.Unit) {
        return <div></div>;
    }
    const text = `${!isPriceRange ? 'Price ' : ''}per ${
        PRICE_UNIT_LABELS[variant.PriceUnit]
    }`;
    if (variant.PriceUnit !== PriceUnitEnum.Box) {
        return <span>{text}</span>;
    }

    const showUnitText =
        variant.QuantityPerUnit > 0 || variant.CoverageArea > 0;

    const unitText =
        (variant.QuantityPerUnit > 0
            ? ` Qty per box: ${variant.QuantityPerUnit}${mobile ? '' : '.'}`
            : '') +
        (variant.CoverageArea > 0
            ? `${mobile ? '\n' : ''}Coverage area: ${
                  variant.CoverageArea / 10000
              }m²${mobile ? '' : '.'}`
            : '');

    return mobile ? (
        <span>
            {text} {showUnitText && <MobileUnitText variant={variant} />}
        </span>
    ) : (
        <span>
            {(unitText ? text + '.' + unitText : text).replace(/\.$/, '')}
        </span>
    );
};

const MobileUnitText = ({
    variant,
}: {
    variant: Pick<Variant, 'PriceUnit' | 'QuantityPerUnit' | 'CoverageArea'>;
}) => {
    const coverageArea = <>Coverage area: {variant.CoverageArea / 10000}m²</>;
    return (
        <span>
            &#8211;{' '}
            {variant.QuantityPerUnit > 0 && (
                <>Qty per box: {variant.QuantityPerUnit}</>
            )}
            {variant.CoverageArea > 0 &&
                (variant.QuantityPerUnit > 0 ? (
                    <div style={{ marginTop: pxToRem(5) }}>{coverageArea}</div>
                ) : (
                    coverageArea
                ))}
        </span>
    );
};
